import * as actionsType from '../actions/actionsType';

const initialState = {
    loading: false,
    error: null,
    fare: null,
    durationText: null,
    distanceText: null,
    durationValue: null,
    distanceValue: null,
    totalPrice: null,
};

const getTotalPrice = (fare, duration, distance) => {
    const travelTimeFare = duration / 60 * fare.costPerMinute;
    const travelDistanceFare = distance / 1000 * fare.costPerKm;
    const totalPrice = travelTimeFare + travelDistanceFare + fare.baseFare;
    return totalPrice;
}

export const fareReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionsType.SET_DURATION_AND_DISTANCE:
            return {
                ...state,
                durationText: action.leg.duration.text,
                durationValue: action.leg.duration.value,
                distanceText: action.leg.distance.text,
                distanceValue: action.leg.distance.value,

            };
        case actionsType.GET_FARE_START:
            return {
                ...state,
                loading: true,
                error: null,
                fare: null,
            };
        case actionsType.GET_FARE_SUCCESS:
            const totalPrice = getTotalPrice(action.fare, state.durationValue, state.distanceValue);
            return {
                ...state,
                loading: false,
                error: null,
                fare: action.fare,
                totalPrice: parseFloat(totalPrice),
            };
        case actionsType.GET_FARE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                fare: null,
                totalPrice: null,
            };
        default:
            return {
                ...state,
            };
    }
};

export default fareReducer;